import { HeadingConfig } from '.';

export const defaultHomePageHeadingsConfig: HeadingConfig = {
  titleAlignCenter: false,
  gap: 'gap-1',
  withNonBleeding: true,
};
